import {
  Card,
  CardContent,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@design-system';

interface MetricCardProps {
  label: string;
  value: string | number;
  description?: string;
  className?: string;
  valueClassName?: string;
  onClick?: () => void;
}

export function MetricCard({
  label,
  value,
  description,
  className = '',
  valueClassName = '',
  onClick,
}: MetricCardProps) {
  const content = (
    <Card
      className={`border border-gray-200 shadow-sm ${onClick ? 'cursor-pointer transition-shadow hover:shadow-md' : ''} ${className}`}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-600">{label}</p>
            <p className={`mt-2 text-3xl font-bold text-gray-900 ${valueClassName}`}>{value}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );

  if (description) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-help">{content}</div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs">{description}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
